import styles from "./VotesIcon.module.css";
import Icon from "@mdi/react";
import { mdiChevronUp } from "@mdi/js";

export default function VotesIcon(props) {
	return (
		<div className={styles.vote}>
			<div className={styles.item}>
				<Icon path={mdiChevronUp} size={1} />
			</div>
			<hr className={styles.hr} />
			<div className={styles.item}>{props.nbVotes}</div>
		</div>
	);
}
